import { z } from "zod";
import { TaskType } from "@remi/enums/task-type";
import { UploadCompletedWorkPhotosAttemptTypeSchema } from "@remi/enums/upload-completed-work-photos-attempt-type";

export const UploadedCompletedWorkPhotosTaskAttemptSchema = z.object({
  type: z.literal(TaskType.UPLOADED_COMPLETED_WORK_PHOTOS),
  attemptType: UploadCompletedWorkPhotosAttemptTypeSchema,
  requestDescription: z.string().optional(),
  photosUploaded: z.number().optional(),
  workPerformed: z.string().max(5000).optional(),
  remainingWorkNeeded: z.boolean().optional(),
  remainingWorkDescription: z.string().max(5000).optional(),
});

export type UploadedCompletedWorkPhotosTaskAttempt = z.infer<typeof UploadedCompletedWorkPhotosTaskAttemptSchema>;
